














































































































































































































































































































































import QRCode from 'qrcode'
import AbpBase from "../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {GetPatients, InsertPatient, EditPatient, DeletePatient} from '../../../api/specialDictionary'
import {GetProvinceList, GetCityByProvList, GetNationList} from '../../../api/basicDictionary'
import {GetPinYin, GetWuBi} from '../../../api/sys'
import card from './card'
import {GetListByCode} from '../../../api/configureDictionary'
import PatientInfo from './parts/patientInfo'
import {GetDicsByCode} from "@/api/systemBasic"

@Component({
	components: {PatientInfo}
})
export default class Patient extends AbpBase {
	visibleChange(value: boolean) {
		if (!value) {
			this.dialogFormVisible = false;
			(this.$refs.form as any).resetFields()
		}
	}
	drawerShow = false
	advancedSearch(){
		this.drawerShow = true
	}
	searchCancel(){
		this.formData = {
			Sex: '-1',
			AgeFrom: 0,
			AgeTo: 100,
			IsTemp: '-1',
			VaType: [],
			IsOutCome: '0',
			Tag: [],
			QueryString: ''
		}
		this.drawerShow = false
	}
	searchConfirm(){
		this.page = 1
		this.getData()
		this.drawerShow = false
	}
	tags: any = [] // 患者标签
	formData: any = {
		Sex: '-1',
		AgeFrom: 0,
		AgeTo: 100,
		IsTemp: '-1',
		VaType: [],
		IsOutCome: '0',
		Tag: [],
		QueryString: ''
	}
	Url = XMLHTTP_BASEURL
	columns = [
		{
			key: 'patientName',
			width: 110,
			align: 'center',
			title: '患者姓名',
			render: (h: any, p: any) => {
				return h('el-button', {
					props: {type: 'text'},
					style: {fontSize: '15px'},
					on: {
						click: () => {
							this.patientInfo(p.row)
						}
					}
				}, p.row.patientName)
			}
		},
		{
			key: 'cardNo',
			width: 180,
			title: '门诊/住院卡号'
		},
		{
			key: 'dialysisNo',
			title: '透析号'
		},
		{
			key: 'dialysisNo',
			title: '性别',
			render: (h: any, p: any) => {
				return h('span', p.row.sex === 1 ? '男' : p.row.sex === 2 ? '女' : '不明')
			}
		},
		{
			key: 'identityCard',
			title: '证件号码'
		},
		{
			key: 'patVascularAccess',
			title: '通路信息'
		},
		{
			key: 'remarks',
			title: '备注'
		},
		{
			key: '',
			width: 90,
			title: '操作',
			render: (h: any, p: any) => {
				return h('div', [
					h('Button', {
						props: {type: 'primary'},
						style: {marginRight: '20px'},
						on: {
							click: () => {
								this.edit(p.row)
							}
						}
					}, '编辑'),
				])
			}
		},
	]
	types = []  //患者类型下拉
	uts = []  //部门下拉
	provs: any = [] //省下拉
	cities: any = [] //市下拉
	mzs: any = [] //民族
	allMzs:Array<any> = [] //所有民族
	chargeTypes = []  //费用类型下拉
	identityCardTypes = [] //证件类型下拉

	key = '' //查询条件
	page = 1 //当前页
	dialogTitle = ''
	dialogForm: any = {
		cardNo: '',
		pinyin: '',
		wubi: '',
		cityId: '',
		provinceId: ''
	}
	dialogFormVisible = false
	dialogFormLabelWidth = '130px'
	tableTotalSize = 0
	tableData = []
	tableLoading = false
	currentYear = new Date().getFullYear()
	patientInfoShow = false // 患者病历首页
	patientInfoData = {}

	created() {
		this.getData()
		this.getSelects()
	}

	handleSuccess(res: any, file: any) {
		console.log(res)
		let path = res.result.objects.imageAddress
		this.dialogForm.imagePath = this.Url + path
	}

	patientInfo(row: any) {
		this.patientInfoData = row
		this.patientInfoShow = true
	}
	remoteMethod(query:any){
		if (!query) {
			this.mzs = this.allMzs
		} else{
			this.mzs = this.allMzs.filter((item:any)=>{
				let a =  item.nationName.indexOf(query) !== -1
				let b =  item.nationPY.indexOf(query.toUpperCase()) !== -1
				let c =  item.nationWB.indexOf(query.toUpperCase()) !== -1
				return a || b || c
			})
		}
	}
	async getCode(val: any) {
		let query = {inputStr: val}
		let res1 = await GetPinYin(query)
		let res2 = await GetWuBi(query)
		this.dialogForm.pinyin = res1
		this.dialogForm.wubi = res2
	}

	createCounty() {
		this.dialogTitle = '新增患者'
		this.dialogFormVisible = true
	}

	async identityCardInput(val: any) {
		if (val.length === 18 && this.dialogForm.identityCardType === 1038) {
			this.generateQrcode(val)
			const provinceNo = val.substring(0, 2) + '0000'
			const cityNo = val.substring(0, 4) + '00'
			const year = val.substring(6,10)
			const month = val.substring(10,12)
			const day = val.substring(12,14)
			this.dialogForm.dateOfBirth = year + '-' + month + '-' + day
			const provinceName = card.province[provinceNo]
			const cityName = card.city[cityNo]
			let getProv = false // 有没有取到省名称
			for (let i = 0; i < this.provs.length; i++) {
				if (this.provs[i].provName === provinceName) {
					this.dialogForm.provinceId = this.provs[i].id
					getProv = true
					break
				}
			}
			if (getProv) {
				await this.provChange()
				for (let i = 0; i < this.cities.length; i++) {
					if (this.cities[i].cityName === cityName) {
						this.dialogForm.cityId = this.cities[i].id
						break
					}
				}
			}

			console.log(provinceName, cityName)
		}
	}

	deptChange(val: any) {
		this.dialogForm.deptType = val.id
		this.dialogForm.deptTypeName = val.text
	}

	async provChange() {
		let res = await GetCityByProvList({id: this.dialogForm.provinceId})
		this.cities = res
	}

	private async getData() {
		this.tableLoading = true
		let query:any = {
			AgeFrom: this.formData.AgeFrom,
			AgeTo: this.formData.AgeTo,
			QueryString: this.key,
			SkipCount: this.page,
			MaxResultCount: 10,
			VaType: this.formData.VaType.join(';'),
			Tag: this.formData.Tag.join(';')
		}
		if (this.formData.Sex !== '-1') {
			query.Sex = this.formData.Sex
		}
		if (this.formData.IsTemp !== '-1') {
			query.IsTemp = this.formData.IsTemp === '1'
		}
		if (this.formData.IsOutCome !== '-1') {
			query.IsOutCome = this.formData.IsOutCome === '1'
		}
		let res = await GetPatients(query)
		this.tableData = res.items
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
	}

	async getSelects() {
		let res = await GetListByCode({input: '023'})
		this.chargeTypes = res
		let res1 = await GetListByCode({input: '016'})
		this.identityCardTypes = res1
		// let res1 = await GetListByCode({input:'021'})
		// this.types = res
		let res2 = await GetProvinceList({QueryString: '', SkipCount: 1, MaxResultCount: 10000})
		this.provs = res2.items
		let resTags = await GetDicsByCode({code: 'tag'})
		this.tags = resTags.objects
		let mzs = await GetNationList({
			QueryString: '',
			SkipCount: 1,
			MaxResultCount: 100
		})
		this.allMzs = mzs.items
		this.mzs = mzs.items
	}

	handleClose() {
		this.dialogFormVisible = false
	}

	edit(row: any) {
		this.dialogTitle = '编辑患者'
		this.dialogForm = JSON.parse(JSON.stringify(row))
		this.dialogFormVisible = true
		this.identityCardInput(this.dialogForm.identityCard)
	}

	async del(row: any) {
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeletePatient({Id: row.id})
			this.getData()
		}).catch(() => {

		});

	}

	async confirm() {
		(this.$refs.form as any).validate(async (valid: boolean) => {
			if (valid) {
				if (this.dialogTitle === '新增患者') {
					let res = await InsertPatient(this.dialogForm)
				} else if (this.dialogTitle === '编辑患者') {
					let res = await EditPatient(this.dialogForm)
				}
				this.dialogFormVisible = false
				this.getData()
			}
		})
	}

	// birthdayChange(){
	// 	let currentYear = new Date().getFullYear()
	// 	let year = (this.dialogForm.birthday as Date).getFullYear()
	// 	this.dialogForm.age = currentYear - year + 1
	// }
	rules = {
		patientName: [{required: true, message: '请输入内容', trigger: 'blur'}],
		wubi: [{required: true, message: '请输入内容', trigger: 'blur'}],
		pinyin: [{required: true, message: '请输入内容', trigger: 'blur'}],
		pinyin: [{required: true, message: '请输入内容', trigger: 'blur'}],
		dosage: [{required: true, message: '请输入内容', trigger: 'blur'}],
		identityCard: [{required: true, message: '请输入内容', trigger: 'blur'}],
		identityCardType: [{required: true, message: '请选择',}],
		sex: [{required: true, message: '请选择',}],
		chargeType: [{required: true, message: '请选择',}],
		provinceId: [{required: true, message: '请选择',}],
		cityId: [{required: true, message: '请选择',}],
		dateOfBirth: [{required: true, message: '请选择',}],
		// manWB:[{required: true, message: '请输入内容', trigger: 'blur'}],
	}

	pageChange(val: any) {
		this.page = val
		this.getData()
	}

	private async generateQrcode(num: any) {
		var canvas = document.getElementById('canvas')
		QRCode.toCanvas(canvas, num, function (error: any) {
			if (error) console.error(error)
			console.log('QRCode success!');
		})

	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/index.vue